import dynaForms from '@elab/core/utils/dynaForms';

const getTypes = storeName => ({
    ...dynaForms.getTypes(storeName),
    SET_DATA_FIELD_VALUE: `${storeName}.SET_DATA_FIELD_VALUE`,
    SET_FAKE_VALIDATION: `${storeName}.SET_FAKE_VALIDATION`,
    SET_EDITING: `${storeName}.SET_EDITING`,
    OPEN_FORM_IN_DIALOG: `${storeName}.OPEN_FORM_IN_DIALOG`,
    RESET: `${storeName}.RESET`,
    SET_ADDRESS_TYPE: `${storeName}.SET_ADDRESS_TYPE`,
    SET_RADIO_VIEW: `${storeName}.SET_RADIO_VIEW`,
    SET_SUBMIT_EDIT_URL: `${storeName}.SET_SUBMIT_EDIT_URL`,
    SET_SUBMIT_ADD_URL: `${storeName}.SET_SUBMIT_ADD_URL`,
    SET_SUBMIT_EDIT_METHOD: `${storeName}.SET_SUBMIT_EDIT_METHOD`,
    SET_SELECT_FOR_PAYMENT_AFTER_EDITING: `${storeName}.SET_SELECT_FOR_PAYMENT_AFTER_EDITING`,
});

export default getTypes;
